export default class SDAGEDto {
    constructor(obj) {
        this.id = obj.id // Int
        this.startDate = obj.startDate // Option[DateTime]
        this.endDate = obj.endDate // Option[DateTime]
        this.codeSDAGE = obj.codeSDAGE // Option[Int]
        this.comment = obj.comment // Option[String]
        this.contributor = obj.contributor // Option[Int]
    }
}